/**
 * APP 环境跳转到小程序
 */
import { Level, reportCustomMetric, reportError } from "../owl";
import { BridgeType, callGrowthMSIBridge, callKNBBridge, callMSIBridge, getBridgeType } from "./base";

/* ----- MSI.openLink 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?id=3320&tab=C
interface MSIOpenWxMiniProgramProps {
  miniProgramId: string; // 小程序原始 ID
  path: string;
  type: OpenMiniProgramEnvEnum;
  success?: (res: MSIOpenWxMiniProgramSuccessCbParams) => void;
  fail?: (err: MSIOpenWxMiniProgramFailCbParams) => void;
  complete?: () => void;
}

interface MSIOpenWxMiniProgramSuccessCbParams {
  errMsg: string; // 响应信息
  errno: number; // 响应码
  result: string; // 结果值
}

interface MSIOpenWxMiniProgramFailCbParams {
  errMsg: string; // 响应信息
  errno: number; // 响应码
}
/* ----- MSI.openLink 类型声明 end ----- */

/* ----- KNB.openPage 类型声明 start ----- */
// https://km.sankuai.com/collabpage/418106045
export enum OpenMiniProgramEnvEnum {
  RELEASE = 0, // 正式版
  DEVELOP = 1, // 开发版
  PREVIEW = 2, // 体验版
}
interface KNBOpenMiniProgramProps {
  miniProgramId: string; // 小程序原始 ID
  path: string;
  type: OpenMiniProgramEnvEnum;
  success?: () => void;
  fail?: (err: any) => void;
}
/* ----- KNB.openPage 类型声明 end ----- */

interface OpenMiniProgramProps {
  miniProgramId: string;
  path: string;
  type?: OpenMiniProgramEnvEnum;
  onSuccess?: () => void;
  onFail?: (err: any) => void;
}

const bridgeType = getBridgeType();

type OpenMiniProgramErrMsg = 'success' | 'KNBBridgeFail' | 'MSIBridgeFail' | 'GrowthMSIBridgeFail' | 'emptyPath';
function reportOpenMiniProgramSuccessRate(isSuccess: boolean, errMsg: OpenMiniProgramErrMsg = "success") {
  reportCustomMetric({
    key: "openMiniProgram",
    value: isSuccess ? 1 : 0,
    tags: {
      errMsg,
      bridgeType,
    },
  });
}

export default function openMiniProgram(props: OpenMiniProgramProps) {
  if (!props.path) {
    reportOpenMiniProgramSuccessRate(false, 'emptyPath');
    reportError({
      name: "[openMiniProgram] openMiniProgramError",
      msg: "props.path is empty",
      category: "bridgeError",
      level: Level.ERROR,
    });
    return;
  }
  switch (bridgeType) {
    case BridgeType.KNB:
      callKNBBridge("openMiniProgram", {
        miniProgramId: props.miniProgramId,
        path: props.path,
        type: props.type || OpenMiniProgramEnvEnum.RELEASE,
        success: () => {
          if (typeof props.onSuccess === "function") {
            props.onSuccess();
          }
          reportOpenMiniProgramSuccessRate(true);
        },
        fail: function (error) {
          if (typeof props.onFail === "function") {
            props.onFail(error);
          }
          reportError({
            name: "[openMiniProgram] KNBOpenMiniProgramError",
            msg: error,
            category: "bridgeError",
            level: Level.WARN,
          });
          reportOpenMiniProgramSuccessRate(false, 'KNBBridgeFail');
        },
      } as KNBOpenMiniProgramProps);
      break;
    case BridgeType.MSI:
      callMSIBridge("openWxMiniProgram", {
        miniProgramId: props.miniProgramId,
        path: props.path,
        type: props.type || OpenMiniProgramEnvEnum.RELEASE,
        success: () => {
          if (typeof props.onSuccess === "function") {
            props.onSuccess();
          }
          reportOpenMiniProgramSuccessRate(true);
        },
        fail: (err: any) => {
          if (typeof props.onFail === "function") {
            props.onFail(err);
          }
          reportError({
            name: "[openMiniProgram] MSIOpenWxMiniProgramError",
            msg: err,
            category: "bridgeError",
            level: Level.WARN,
          });
          reportOpenMiniProgramSuccessRate(false, 'MSIBridgeFail');
        },
      } as MSIOpenWxMiniProgramProps);
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("openWxMiniProgram", {
        miniProgramId: props.miniProgramId,
        path: props.path,
        type: props.type || OpenMiniProgramEnvEnum.RELEASE,
        success: () => {
          if (typeof props.onSuccess === "function") {
            props.onSuccess();
          }
          reportOpenMiniProgramSuccessRate(true);
        },
        fail: (err: any) => {
          if (typeof props.onFail === "function") {
            props.onFail(err);
          }
          reportError({
            name: "[openMiniProgram] GrowthMSIOpenWxMiniProgramError",
            msg: err,
            category: "bridgeError",
            level: Level.WARN,
          });
          reportOpenMiniProgramSuccessRate(false, 'GrowthMSIBridgeFail');
        },
      } as MSIOpenWxMiniProgramProps);
      break;
    default:
      break;
  }
}
